export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
  'team_presence_manage',
  'inbox_manage',
  'captain_manage',
  'company_manage',
  'campaign_manage',
  'search_manage',
  'canned_response_manage',
  'portfolio_manage',
  'integration_manage',
  'whatsapp_keys_manage',
  'managed_inboxes_manage',
  'settings_manage',
  'conversation_view',
  'conversation_page_access',
  'conversation_create',
  'conversation_reply',
  'conversation_claim',
  'conversation_transfer',
  'conversation_resolve',
  'conversation_reopen',
  'granular_page_access',
  'page_team_presence',
  'page_inbox',
  'page_conversations_all',
  'page_conversations_mentions',
  'page_conversations_participating',
  'page_conversations_unattended',
  'page_conversations_folders',
  'page_conversations_teams',
  'page_conversations_channels',
  'page_conversations_labels',
  'page_captain_faqs',
  'page_captain_documents',
  'page_captain_scenarios',
  'page_captain_playground',
  'page_captain_inboxes',
  'page_captain_tools',
  'page_captain_settings',
  'page_contacts_all',
  'page_contacts_active',
  'page_contacts_segments',
  'page_contacts_labels',
  'page_companies_all',
  'page_campaigns_live_chat',
  'page_campaigns_sms',
  'page_campaigns_whatsapp',
  'page_search',
  'page_canned_responses',
  'page_portfolio',
  'page_integrations',
  'page_settings_agents',
  'page_settings_teams',
  'page_settings_canned_responses',
  'page_settings_team_numbers',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'conversation_page_access',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    // Aceleres: aba "Novas" só pra admin/gestor. Vendedores recebem leads
    // via round-robin automático, não precisam ver pool de não-atribuídas.
    permissions: [
      'administrator',
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    // Aceleres: aba "Todos" só pra admin/gestor. Agents (vendedores)
    // só veem Minhas/Novas/Pessoais.
    permissions: [
      'administrator',
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
  personal: {
    count: 'personalCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
};
